"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lottieAnimation = _interopRequireDefault(require("./lottie-animation"));

var _default = _lottieAnimation.default;
exports.default = _default;